import { useEffect, useState } from "react";
import {
  collection,
  query as firestoreQuery,
  where,
  orderBy,
  onSnapshot,
} from "firebase/firestore";
import { projectFirestore } from "../firebase/config";

export const useCollection = (collectionName, queryObj, orderByObj) => {
  // State to hold documents and error
  const [documents, setDocuments] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Reset state on collection change
    let ref = collection(projectFirestore, collectionName);

    // Apply query if specified
    if (queryObj?.field && queryObj?.operator && queryObj?.value !== undefined)
      ref = firestoreQuery(ref, where(queryObj.field, queryObj.operator, queryObj.value));

    // Apply ordering if specified
    if (orderByObj?.field && orderByObj?.direction)
      ref = firestoreQuery(ref, orderBy(orderByObj.field, orderByObj.direction));

    // Listen for real-time updates
    const unsubscribe = onSnapshot(
      ref,
      (snapshot) => {
        const results = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setDocuments(results);
        setError(null);
      },
      (err) => {
        setError("Could not fetch data");
      }
    );

    return () => unsubscribe();
  }, [
    collectionName,
    queryObj?.field,
    queryObj?.operator,
    queryObj?.value,
    orderByObj?.field,
    orderByObj?.direction,
  ]);

  return { documents, error };
};
